import React, { Component } from 'react';

import OrdersProgressTable from './../components/OrdersProgressTable';
import OrderProgressTabPage from './OrderProgressTabPage';

const myPath = '/myorders/inprogress';

class MyOrdersProgressPage extends Component {
    constructor(props) {
        super(props);

        this.onSelect = this.onSelect.bind(this);
    }

    onSelect(orderNumber) {
        const { history, match } = this.props;
        const prevOrderNumber = match.params.orderNumber;
        if (prevOrderNumber === orderNumber) {
            history.push(myPath);
            return;
        }
        history.push(`${myPath}/${orderNumber}`);
    }

    render() {
        const { match } = this.props;
        const orderNumber = match.params.orderNumber;
        return (
            <div className="container">
                <OrdersProgressTable onSelect={this.onSelect} selectedNumber={orderNumber} />
                {!!orderNumber &&
                    <OrderProgressTabPage orderNumber={orderNumber} onSelect={this.onSelect} />
                }
            </div>
        );
    };
}

export default MyOrdersProgressPage;


// WEBPACK FOOTER //
// ./src/pages/MyOrdersProgressPage.js